// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"4d178fb9","343":"4d30d18e"}[chunkId] + ".chunk.css";
};